import * as React from 'react';
// TODO: Remove when use `responsiveImmutable`
var PerfContext = /*#__PURE__*/React.createContext({
  renderWithProps: false
});
export default PerfContext;